module.exports = __webpack_public_path__ + "img/sharpreflections.138defb7.svg";